import React, { useEffect } from "react";
import { useState } from "react";
const TransportServiceArea = () => {
  const [email, setEmail] = useState(`${localStorage.getItem("EMAIL_PREFIX")}@${localStorage.getItem("DOMAIN")}`);

  useEffect(() => {
    setEmail(`${localStorage.getItem("EMAIL_PREFIX")}@${localStorage.getItem("DOMAIN")}`);
  }, [
    localStorage.getItem("EMAIL_PREFIX"),
    localStorage.getItem("DOMAIN"),
  ]);
  return (
    <>
      {/* Transport service area start */}
      <div className='transport-service-area'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='section-title  text-center'>
                <span className='subtitle'>Our Services</span>
                <h2 className='title'>What We Can Do For You</h2>
              </div>
            </div>
          </div>
          <div className='row transport-service-single'>
            <div className='col-lg-6'>
              <div className='transport-service-image wow fadeInLeft'>
                <img
                  src='https://images.unsplash.com/photo-1526367790999-0150786686a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjZ8fGNvdXJpZXJ8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=900&q=60'
                  className='img-fluid'
                  alt='transport-service images'
                />
                <div className='transport-service-item-hover'>
                  <a href='#'>
                    <div className='transport-service-link'>
                      <span className='fa fa-eye' />
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className='col-lg-4 offset-lg-1 d-flex'>
              <div className='transport-service-content wow fadeInRight'>
                <h3 className='title'>Transportation and Freight Management</h3>
                <p>
                  We provide reliable transportation services to ensure the smooth movement of your goods. Whether it's by road, air, sea, or rail, we have the expertise and network to handle your shipments efficiently.
                </p>
                <div className='btn-wrapper animated fadeInUpBig text-left'>
                   <a href={`mailto:${email}`} className='boxed-btn blank'>
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className='row transport-service-single'>
            <div className='col-lg-6 offset-lg-1 order-lg-2'>
              <div className='transport-service-image wow fadeInRight'>
                <img
                  src='https://plus.unsplash.com/premium_photo-1663134275544-7d83fcfa0e54?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzF8fGNvdXJpZXJ8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=900&q=60'
                  className='img-fluid'
                  alt='transport-service images'
                />
                <div className='transport-service-item-hover'>
                  <a href='#'>
                    <div className='transport-service-link'>
                      <span className='fa fa-eye' />
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className='col-lg-4 offset-lg-1 d-flex '>
              <div className='transport-service-content wow fadeInLeft'>
                <h3 className='title'>Warehousing and Distribution</h3>
                <p>
                  Our state-of-the-art warehousing facilities offer secure storage for your products. We provide inventory management, order fulfillment, and value-added services to streamline your distribution processes
                </p>
                <div className='btn-wrapper animated fadeInUpBig text-left'>
                <a href={`mailto:${email}`} className='boxed-btn blank'>
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className='row transport-service-single'>
            <div className='col-lg-6'>
              <div className='transport-service-image wow fadeInLeft'>
                <img
                  src='https://media.istockphoto.com/id/1318229078/photo/asian-chinese-mature-male-delivery-person-using-digital-tablet-mobile-app-checking-delivery.webp?b=1&s=170667a&w=0&k=20&c=4SGbnwA6zcjsUicQIYbbvZgzlYNh7nE2zQm4ozIrrPA='
                  className='img-fluid'
                  alt='transport-service images'
                />
                <div className='transport-service-item-hover'>
                  <a href='#'>
                    <div className='transport-service-link'>
                      <span className='fa fa-eye' />
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className='col-lg-4 offset-lg-1 d-flex'>
              <div className='transport-service-content wow fadeInRight'>
                <h3 className='title'>Customs Clearance and Trade Compliance</h3>
                <p>
                  Navigating the complexities of customs regulations and trade compliance can be challenging. Our experienced team ensures smooth customs clearance, minimizing delays and avoiding costly penalties.
                </p>
                <div className='btn-wrapper animated fadeInUpBig text-left'>
                <a href={`mailto:${email}`} className='boxed-btn blank'>
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className='row justify-content-center'>
            <div className='col-lg-2'>
              <div className='btn-wrapper animated fadeInUpBig text-center'>
                <a href='#' className='boxed-btn btn-bounce'>
                  View All
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Transport service area end */}
    </>
  );
};

export default TransportServiceArea;
